module.exports = __webpack_public_path__ + "img/icon_no_card.f1be2201.png";